import React, { useState } from "react";

// Sample data for the invoices
const initialData = [
  {
    SrNo: 1,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 60000,
    OrderId: "7F4128B4A25FDA4CC0A985DA87F29140206",
    TxnNo: "TXN207480129",
    TxnDate: "29-11-2024",
    Service: "Credit Card",
    Status: "Captured",
  },
  {
    SrNo: 2,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 60000,
    OrderId: "70BC7388A4AB8A451CA9865A5FF29140205",
    TxnNo: "TXN91450752",
    TxnDate: "29-11-2024",
    Service: "Credit Card",
    Status: "Captured",
  },
  {
    SrNo: 3,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 6500,
    OrderId: "0BEB7085A28BEA4028ABAF1A02E28140519",
    TxnNo: "TXN808353068",
    TxnDate: "28-11-2024",
    Service: "Credit Card",
    Status: "Captured",
  },
  {
    SrNo: 4,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 600,
    OrderId: "7DFB5B73AD40EA486AAB562A58428140218",
    TxnNo: "TXN281195420",
    TxnDate: "28-11-2024",
    Service: "Loan Repayment",
    Status: "Captured",
  },
  {
    SrNo: 5,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 11000,
    OrderId: "223D02ABA83B1A4C5DAB4A3A64828140139",
    TxnNo: "TXN341879767",
    TxnDate: "28-11-2024",
    Service: "Credit Card",
    Status: "Captured",
  },
  {
    SrNo: 6,
    MobileNo: "8569841235",
    Name: "JITENDRA KUMAR",
    Email: "rajjitendra845@gmail.com",
    Amount: 199,
    OrderId: "D058F15EAC8BDA44EDA826FA4F825140820",
    TxnNo: "TXN882680545",
    TxnDate: "25-11-2024",
    Service: "Mobile Recharge",
    Status: "Failed",
  },
  {
    SrNo: 7,
    MobileNo: "9044750234",
    Name: "AKANKSHA KUSHWAHA",
    Email: "akankshakushwaha482@gmail.com",
    Amount: 99,
    OrderId: "41097B02A79E3A43A9AAE91AE9822140549",
    TxnNo: "TXN100658763",
    TxnDate: "22-11-2024",
    Service: "Mobile Recharge",
    Status: "Captured",
  },
  {
    SrNo: 8,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 199,
    OrderId: "6232F763A6E15A4A3BAB91BAEE217141231",
    TxnNo: "TXN816628496",
    TxnDate: "17-11-2024",
    Service: "Mobile Recharge",
    Status: "Captured",
  },
  {
    SrNo: 9,
    MobileNo: "7651865251",
    Name: "Manish Singh Kushwaha",
    Email: "manuraj94@gmail.com",
    Amount: 199,
    OrderId: "5A7D24A2A127DA4722A9770AAFF04141239",
    TxnNo: "TXN297517072",
    TxnDate: "04-11-2024",
    Service: "Mobile Recharge",
    Status: "Captured",
  },
  {
    SrNo: 10,
    MobileNo: "9795225773",
    Name: "Deepankar Kushwaha",
    Email: "dkdeep786@gmail.com",
    Amount: 200,
    OrderId: "3FAF1AE3AA65CA40AEA9622AC4631040719",
    TxnNo: "TXN895065104",
    TxnDate: "31-10-2024",
    Service: "Fasttag Payment",
    Status: "Failed",
  },
];

const itemsPerPage = 5; // Number of items per page

const RechargeAndBillInvoice = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Filter data based on the search query
  const filteredData = data.filter((item) => {
    return (
      item.MobileNo.includes(searchQuery) ||
      item.Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.Email.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  // Paginate filtered data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to page 1 when search query changes
  };

  // Show all data
  const showAllData = () => {
    setData(initialData);
    setCurrentPage(1); // Reset to page 1
  };

  // Handle next page
  const handleNext = () => {
    if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle previous page
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Generate page numbers for pagination
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      <h1 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "20px" }}>
        Recharge and Bill Invoice
      </h1>

      {/* Search Input and Show Button */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Search by Mobile No., Name, or Email"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
            padding: "8px",
            width: "250px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            marginRight: "10px",
          }}
        />
        <button
          onClick={showAllData}
          style={{
            padding: "8px 16px",
            fontSize: "14px",
            borderRadius: "4px",
            backgroundColor: "#007BFF",
            color: "white",
            border: "none",
          }}
        >
          Show All
        </button>
      </div>

      {/* Invoice Table with Scroll */}
      <div style={{ overflowX: "auto", marginTop: "20px" }}>
        <table
          style={{
            width: "100%",
            minWidth: "900px",
            borderCollapse: "collapse",
            fontSize: "14px",
            border: "1px solid #ddd",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f4f4f4" }}>
              <th style={cellStyle}>Sr.No.</th>
              <th style={cellStyle}>Mobile No.</th>
              <th style={cellStyle}>Name</th>
              <th style={cellStyle}>Email</th>
              <th style={cellStyle}>Amount</th>
              <th style={cellStyle}>Order Id</th>
              <th style={cellStyle}>Txn No.</th>
              <th style={cellStyle}>Txn Date</th>
              <th style={cellStyle}>Service</th>
              <th style={cellStyle}>Status</th>
              <th style={cellStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item) => (
              <tr key={item.SrNo} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={cellStyle}>{item.SrNo}</td>
                <td style={cellStyle}>{item.MobileNo}</td>
                <td style={cellStyle}>{item.Name}</td>
                <td style={cellStyle}>{item.Email}</td>
                <td style={cellStyle}>{item.Amount}</td>
                <td style={cellStyle}>{item.OrderId}</td>
                <td style={cellStyle}>{item.TxnNo}</td>
                <td style={cellStyle}>{item.TxnDate}</td>
                <td style={cellStyle}>{item.Service}</td>
                <td style={cellStyle}>{item.Status}</td>
                <td style={cellStyle}>
                  <button style={buttonStyle}>Get Invoice</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          style={paginationButtonStyle}
        >
          Previous
        </button>

        {/* Page Numbers */}
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => setCurrentPage(number)}
            style={{
              padding: "8px 16px",
              fontSize: "14px",
              borderRadius: "4px",
              backgroundColor: currentPage === number ? "#007BFF" : "#f4f4f4",
              color: currentPage === number ? "white" : "black",
              marginLeft: "5px",
              border: "1px solid #ddd",
            }}
          >
            {number}
          </button>
        ))}

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          style={paginationButtonStyle}
        >
          Next
        </button>
      </div>
    </div>
  );
};

// Common styles for table cells
const cellStyle = {
  padding: "10px",
  borderLeft: "1px solid #ddd",
  borderRight: "1px solid #ddd",
  textAlign: "center",
};

// Button styles
const buttonStyle = {
  fontSize: "12px",
  padding: "5px 10px",
  backgroundColor: "#007BFF",
  color: "white",
  border: "none",
  borderRadius: "4px",
};

// Pagination button style
const paginationButtonStyle = {
  padding: "8px 16px",
  fontSize: "14px",
  borderRadius: "4px",
  backgroundColor: "#007BFF",
  color: "white",
  border: "none",
  marginRight: "10px",
};

export default RechargeAndBillInvoice;
